import CardBase from '@mnd-frontend/ui/public/components/CardBase';
import { Icons } from '@mnd-frontend/ui/publish/components';
import {
  BREAKPOINTS,
  SIZING_4,
  SPACING_2,
  SPACING_4,
  SPACING_5,
} from '@mnd-frontend/ui/shared/tokens';
import type { ThemeUnion } from '@mnd-frontend/ui/shared/types/color';
import styled, { css } from 'styled-components';
import type { IconNameUnion, StatCardProps } from './index.type';

// #region Styled component
const Card = styled(CardBase)<{ $theme?: ThemeUnion }>`
  padding: ${SPACING_4};
  margin-right: ${SPACING_2};
  margin-left: ${SPACING_2};

  ${({ $theme }) =>
    $theme === 'dark'
      ? css`
        background-color: #181646;

        .label {
          color: #FFAC70;
        }

        .sub-text {
          color: #fff;
        }

        .icon {
          color: #fff;
        }
    `
      : css`
        background-color: #fff;
        color: #181646;

        .icon {
          color: #181646;
        }
  `};

  @media (min-width: ${BREAKPOINTS.MD}px) {
    &:not(:last-of-type) {
      margin-right: 0;
    }

    &:not(:first-of-type) {
      margin-left: 0;
    }
  }

  @media (min-width: ${BREAKPOINTS.XXL}px) {
    margin: 0;
  }
  
  .icon,
  .icon-placeholder {
    width: ${SIZING_4};
    height: ${SIZING_4};
  }

  .label {
    font-size: 2.5rem;
    font-weight: 600;
    margin-top: ${SPACING_5};
  }
`;
// #endregion

const isValueIconKey = (icon: string | IconNameUnion | null | undefined): icon is IconNameUnion => {
  return !!icon && Object.keys(Icons).includes(icon);
};

const CardIcon = ({ icon, className }: { className: string; icon?: string | null }) => {
  if (!isValueIconKey(icon)) {
    return <div className="icon-placeholder" aria-hidden></div>;
  }

  const IconComponent = Icons[icon];
  return <IconComponent className={className} />;
};

const StatCard = ({ label, subText, colorScheme, icon }: StatCardProps) => (
  <Card as="li" $theme={colorScheme}>
    <CardIcon icon={icon?.[0]} className="icon" />
    <div className="label">{label}</div>
    {subText && <span className="sub-text">{subText}</span>}
  </Card>
);

export default StatCard;
